module.exports = "pegasus/assets/web_template/diamond.png";